export default __webpack_public_path__ + "static/media/2AA6548C-3882-4D3C-BBD3-7CAA3A12B50C_1_105_c.e07e67f4.jpeg";